import { useEffect, useState } from "react";
// import NewsCard from "./NewsCard";
import axios from "axios";
// import { useContext } from "react";
// import { UserContext } from "../context/UserContext";
import { Link, NavLink } from "react-router-dom";
import { FaCheckSquare } from "react-icons/fa";
import { BiSolidXSquare } from "react-icons/bi";
// import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";
import PredictionCard from "./PredictionCard";
import MurqueContainer from "./MurqueContainer";

export default function FreeOddSection({ title, header, showExpert = false }) {
  // const [leagues, setLeagues] = useState([]);
  // const { news } = useContext(UserContext);
  const [bet, setBet] = useState({});
  const [expertBet, setExpertBet] = useState({});
  const [betResults, setBetResults] = useState({});
  const [loading, setLoading] = useState(true);
  // const randomNews = Math.floor(Math.random() * news.length);

  useEffect(() => {
    axios
      .get(`/bet/${title}`)
      .then(({ data }) => {
        setBet(data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`/bet/expert`)
      .then(({ data }) => {
        setExpertBet(data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`/result/${title}`)
      .then(({ data }) => {
        setBetResults(data);
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get("/league")
    //   .then(({ data }) => {
    //     setLeagues(data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    setLoading(false);
  }, [title]);

  // const leagueElements = leagues.map((league) => (
  //   <li key={league._id}>{league.titleShort}</li>
  // ));

  // console.log(bet);

  const betElement = bet.betList?.map((bet, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      {/* <td>{bet.country.long}</td> */}
      <td
        style={{
          fontWeight: 600,
          opacity: 0.8,
        }}
      >
        {bet.teams.home.long} vs {bet.teams.away.long}
      </td>
      <td
        style={{
          color: "#007bff",
        }}
      >
        {bet.tip.long}
      </td>
      <td>{bet.time}</td>
      <td
        style={{
          textAlign: "center",
          color: "#3c84b8ff",
          fontWeight: "500",
        }}
      >
        N/A
      </td>
    </tr>
  ));

  const expertElement = expertBet.betList?.map((bet, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      {/* <td>{bet.country.long}</td> */}
      <td
        style={{
          fontWeight: 600,
          opacity: 0.8,
        }}
      >
        {bet.teams.home.long} vs {bet.teams.away.long}
      </td>
      <td
        style={{
          color: "#007bff",
        }}
      >
        {bet.tip.long}
      </td>
      <td>{bet.time}</td>
      <td
        style={{
          textAlign: "center",
          color: "#3c84b8ff",
          fontWeight: "500",
        }}
      >
        N/A
      </td>
    </tr>
  ));

  const betResultsElement = betResults.betList?.map((bet, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      {/* <td>{bet.country.long}</td> */}
      <td
        style={{
          fontWeight: 600,
          opacity: 0.8,
        }}
      >
        {bet.teams.home.long} vs {bet.teams.away.long}
      </td>
      <td
        style={{
          color: "#007bff",
        }}
      >
        {bet.tip.long}
      </td>
      <td>{bet.time}</td>
      <td
        style={{
          textAlign: "center",
        }}
      >
        {bet?.outcome ? (
          <FaCheckSquare className="icon_won" />
        ) : (
          <BiSolidXSquare className="icon_lost" />
        )}
      </td>
    </tr>
  ));

  const btnElements = bet.betRefUrl?.map((bet) => (
    <Link to={bet.url} key={bet.type}>
      <button
        className="ref_btn"
        style={
          bet.type[0] === "S"
            ? { color: "white", backgroundColor: "red" }
            : bet.type[0] === "B"
            ? { color: "white", backgroundColor: "black" }
            : { color: "yellow", backgroundColor: "black" }
        }
      >
        {bet.type}
      </button>
    </Link>
  ));

  const expertBtnElements = expertBet.betRefUrl?.map((bet) => (
    <Link to={bet.url} key={bet.type}>
      <button
        className="ref_btn"
        style={
          bet.type[0] === "S"
            ? { color: "white", backgroundColor: "red" }
            : bet.type[0] === "B"
            ? { color: "white", backgroundColor: "black" }
            : { color: "yellow", backgroundColor: "black" }
        }
      >
        {bet.type}
      </button>
    </Link>
  ));

  return (
    <section className="free_section">
      {/* <h2>{header}</h2> */}
      {loading ? (
        <div className="loading_container">
          <div className="loading_spinner"></div>
          {/* <p>Loading Plans...</p> */}
        </div>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              flex: 1,
              margin: "2rem 0",
            }}
          >
            <MurqueContainer />
          </div>


          <div className="free_bet_section_container">
            <div className="bet_container">
              {
                // <div
                //   className="free_bet_container"
                //   style={{
                //     borderTopLeftRadius: "1rem",
                //     borderTopRightRadius: "1rem",
                //   }}
                // >
                //   <div
                //     style={{
                //       display: "flex",
                //       justifyContent: "space-between",
                //       alignItems: "center",
                //       padding: "0.5rem 0",
                //       width: "100%",
                //       color: "white",
                //       backgroundColor: "red",
                //       cursor: "pointer",
                //     }}
                //     onClick={() => {
                //     }}
                //   >
                //     <span
                //       style={{
                //         color: "white",
                //         padding: "0.5rem 1rem",
                //         border: "none",
                //         fontWeight: "bold",
                //         fontSize: "1rem",
                //       }}
                //     >
                //       {" "}
                //       Previous Bet Results 😃🎉
                //     </span>
                //     <MdArrowDropUp size={30} />
                //   </div>
                //   <div className="bet_list_container">
                //     <table className="free_daily_bet">
                //       <thead>
                //         <tr>
                //           <th></th>
                //           {/* <th>League</th> */}
                //           <th>Team</th>
                //           <th>Tips</th>
                //           <th>Time</th>
                //           <th>Results</th>
                //         </tr>
                //       </thead>
                //       <tbody>{betResultsElement}</tbody>
                //     </table>
                //     {/* <div className="ref_btn_container">{btnElements}</div> */}
                //   </div>
                // </div>
              }

              {bet.betList === undefined ? (
                <div
                  style={{
                    // backgroundColor: "rgba(137, 137, 137, 1)",
                    margin: "0 1rem",
                    borderRadius: "8px",
                    padding: "1rem",
                    textAlign: "center",
                    backgroundColor: "white",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  <h3
                    style={{
                      color: "hsl(205, 72%, 37%)",
                      fontSize: "1rem",
                      textTransform: "uppercase",
                    }}
                  >
                    Predictions Coming Soon
                  </h3>
                  <p
                    style={{
                      maxWidth: 800,
                      margin: "0 auto",
                    }}
                  >
                    Our expert analysts are currently analyzing matches to
                    provide you with the most accurate predictions. Please check
                    back in a few moments.
                  </p>
                </div>
              ) : (
                <PredictionCard
                  element={betElement}
                  openPrediction={true}
                  btnElements={btnElements}
                  title={bet.titleLong}
                />
              )}

              <PredictionCard
                element={betResultsElement}
                openPrediction={false}
                title={betResults.titleLong}
              />

              {expertBet.betList === undefined && showExpert ? (
                <div
                  style={{
                    // backgroundColor: "rgba(137, 137, 137, 1)",
                    margin: "0 1rem",
                    borderRadius: "8px",
                    padding: "1rem",
                    textAlign: "center",
                    backgroundColor: "white",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  <h3
                    style={{
                      color: "hsl(205, 72%, 37%)",
                      fontSize: "1rem",
                      textTransform: "uppercase",
                    }}
                  >
                    Predictions Coming Soon
                  </h3>
                  <p
                    style={{
                      maxWidth: 800,
                      margin: "0 auto",
                    }}
                  >
                    Our expert analysts are currently analyzing matches to
                    provide you with the most accurate predictions. Please check
                    back in a few moments.
                  </p>
                </div>
              ) : (
                <PredictionCard
                  element={expertElement}
                  openPrediction={false}
                  btnElements={expertBtnElements}
                  title={expertBet.titleLong}
                />
              )}
            </div>

            <div className="free_section_left">
              <NavLink to={"https://1wtauc.com/?p=uok3"}>
                <img
                  src="/ms.jpg"
                  alt="free bet"
                  style={{
                    borderRadius: 0,
                  }}
                />
              </NavLink>

              {/* <div className="leagues">
              <h4>Football Leagues</h4>
              <ul>{leagueElements}</ul>
            </div>
            <div className="tipster_advice">
              <h4>Tipster Advice</h4>

              <div className="a_stars">
                {[1, 2, 3, 4, 5].map((_, index) => (
                  <BiStar key={index} className="icon_star" />
                ))}
              </div>

              <p>
                To all clients, please minimize your betting habits. All tips
                provided here are based purely on my personal intelligence,
                experience, and instincts. Asakaaplay.com is strictly for
                individuals aged 18 and above. BET RESPONSIBLY! Thank you.
              </p>

              <p
                style={{
                  color: "white",
                }}
              >
                @asakaaplay
              </p>
            </div>

            <NewsCard news={news[randomNews]} /> */}
            </div>
          </div>
        </>
      )}
    </section>
  );
}
